import { useSelector } from "react-redux";

const useHasResultsId = () => {
  const { resultsId } = useSelector((state) => state.get("save"));

  return resultsId !== null;
};

export default useHasResultsId;
